* {
  box-sizing: border-box;
}

*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

* {
  scrollbar-width: thin;
  scrollbar-color: var(--chart-104-pressed) var(--white-layout-302-level-1-elevation);
}
*::-webkit-scrollbar-track {
  background: var(--white-layout-300-primary);
}
*::-webkit-scrollbar-thumb {
  background-color: var(--chart-300-icon-buttons);
  border-radius: 6px;
}

:host {
  display: block;
  max-width: 100%;
}

.container {
  width: 100%;
}

#sentinel {
  height: 10px;
}

.list-item {
  &--wrapper {
    padding-top: var(--spacer);
    border-bottom: 1px solid var(--chart-101-pressed-dividers);
    color: var(--chart-300-icon-buttons);
  }
  &--name {
    min-height: calc(4 * var(--spacer));
    display: flex;
    justify-content: center;
    align-items: center;

    gz-text {
      margin-left: var(--spacer);
    }
  }

  &--description {
    min-height: calc(4 * var(--spacer));
    display: flex;
    align-items: center;
  }
}
